<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @selection-change="handleSelectionChange"
        @row-update="rowUpdate" @size-change="pageSizeChange" @current-change="pageChange">
        <!-- <template slot="menuLeft">
          <el-button type="text" icon="el-icon-plus" size="small" plain
            @click.stop="handleAdd">新增</el-button>
          <el-button type="text" icon="el-icon-delete" size="small"
            @click.stop="handleDelete">删除</el-button>
        </template> -->
        <template slot-scope="scope" slot="menu">
          <!-- 查看账户明细 -->
          <el-button type="text" icon="el-icon-view" size="small" @click="handleView(scope.row)">查看明细</el-button>
        </template>
      </avue-crud>
      <el-dialog title="新增材料账户" :visible.sync="dialogVisible" width="50%">
        <el-form :model="formData" ref="form" label-width="120px">
          <el-form-item label="用户名称" prop="userName" required>
            <el-input v-model="formData.userName" placeholder="请输入用户名称" />
          </el-form-item>
          <el-form-item label="用户手机号" prop="userMobile" required>
            <el-input v-model="formData.userMobile" placeholder="请输入用户手机号" />
          </el-form-item>
          <!-- 金额 -->
          <el-form-item label="初始金额" prop="amount" required>
            <!-- 计数器 -->
            <el-input-number v-model="formData.amount" placeholder="请输入初始金额" :min="0" :max="1000000" />
          </el-form-item>
          <!-- 类型 -->
          <el-form-item label="账户类型" prop="type" required>
            <el-select v-model="formData.type" placeholder="请选择账户类型">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input v-model="formData.remarks" placeholder="请输入备注" type="textarea" rows="3" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 账户明细弹窗 -->
      <group-details :visible="detailVisible" :user-id="currentUserId" @close="closeDetail" />
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { materialAccountTableOption } from "@/const/work/waterProof/materialAccountOption";
import { getMaterialAccountList, addMaterialAccount, updateMaterialAccount, deleteMaterialAccount } from "@/api/work/waterProof/materialAccount";
import GroupDetails from './materialAccountDetail.vue'
export default {
  name: "materialAccount",
  components: {
    GroupDetails
  },
  data() {
    return {
      tableOption: materialAccountTableOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      dialogVisible: false,
      formData: {
        userName: '',
        userMobile: '',
        amount: 0,
        type: 'WATERPROOF', // 默认值为防水
        remarks: ''
      },
      // 类型选项列表
      typeOptions: [
        { label: '净水', value: 'PURE_WATER' },
        { label: '防水', value: 'WATERPROOF' },
        { label: '吊顶', value: 'HANG_CEILING' }
      ],
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      detailVisible: false,
      currentUserId: '',
      selectedRows: []
    };
  },
  created() {
    this.handleList();
  },
  watch: {

  },
  mounted() {
  },
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    // 获取材料账户列表
    handleList() {
      this.tableLoading = true;
      const params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
        type: 'WATERPROOF' // 默认查询防水类型
      };
      getMaterialAccountList(params).then(res => {
        console.log('index.vue ~ line: 115 ~ res ->', res);
        this.tableLoading = false;
        if (res.code === '200') {
          const data = JSON.parse(res.data) || [];
          this.tableData = data.rows || [];
          // 由于接口返回的是数组而不是分页对象，这里根据实际情况设置总数
          this.page.total = data.total || 0;
        } else {
          this.tableData = [];
          this.page.total = 0;
          this.$message.error('获取材料账户列表失败');
        }
      }).catch(error => {
        console.log('index.vue ~ line: 128 ~ error ->', error);
        this.tableLoading = false;
        this.tableData = [];
        this.page.total = 0;
        this.$message.error('获取材料账户列表异常');
      });
    },

    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 提交数据
          addMaterialAccount(this.formData).then(response => {
            if (response.code == '200') {
              // 清空表单
              this.formData = {
                userName: '',
                userMobile: '',
                amount: 0,
                type: 'WATERPROOF', // 重置为默认值
                remarks: ''
              };
              this.handleList();
              this.dialogVisible = false;
              this.$message.success('材料账户新增成功');
            } else {
              this.$message.error('材料账户新增失败：' + (response.message || '未知错误'));
            }
          });
        } else {
          this.$message.error('表单验证失败，请检查输入');
        }
      });
    },

    rowUpdate(row, index, done, loading) {
      updateMaterialAccount(row).then(response => {
        if (response.code == '200') {
          this.$message.success('材料账户编辑成功');
          this.handleList();
          loading(false);
          done();
        } else {
          done();
          this.$message.error('材料账户编辑失败：' + (response.message || '未知错误'));
        }
      }).catch(error => {
        console.log('index.vue ~ line: 175 ~ error ->', error);
        done();
        loading(false);
        this.$message.error('材料账户编辑异常');
      });
    },

    handleAdd() {
      this.dialogVisible = true;
    },

    handleView(row) {
      console.log('index.vue ~ line: 184 ~ row ->', row);
      this.currentUserId = row.userId;
      this.detailVisible = true;
    },

    handleDelete() {
      const selections = this.$refs.crud.$refs.table.selection;
      if (!selections || selections.length === 0) {
        this.$message.warning('请先选择要删除的材料账户');
        return;
      }

      this.$confirm(`确定要删除选中的${selections.length}个材料账户吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 获取选中的ID列表
        const ids = selections.map(item => item.id).join(',');

        this.tableLoading = true;
        deleteMaterialAccount(ids).then(response => {
          this.tableLoading = false;
          if (response.code === '200') {
            this.$message.success('删除成功');
            this.handleList();
          } else {
            this.$message.error('删除失败：' + (response.message || '未知错误'));
          }
        }).catch(error => {
          this.tableLoading = false;
          this.$message.error('删除异常');
          console.log('删除材料账户异常:', error);
        });
      }).catch(() => {
        // 用户取消操作
      });
    },

    closeDetail() {
      this.detailVisible = false;
      this.currentUserId = '';
    },

    // 搜索条件变化
    searchChange(params) {
      this.tableLoading = true;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.type = 'WATERPROOF'; // 默认查询防水类型

      getMaterialAccountList(params).then(res => {
        this.tableLoading = false;
        if (res.code === '200') {
          const data = JSON.parse(res.data) || [];
          this.tableData = data.rows || [];
          this.page.total = data.total || 0;
        } else {
          this.tableData = [];
          this.page.total = 0;
          this.$message.error('获取材料账户列表失败');
        }
      }).catch(error => {
        console.log('index.vue ~ line: 250 ~ error ->', error);
        this.tableLoading = false;
        this.tableData = [];
        this.page.total = 0;
        this.$message.error('获取材料账户列表异常');
      });
    },

    // 刷新
    refreshChange(page) {
      this.tableLoading = true;
      let params = {
        page: page.currentPage,
        size: page.pageSize,
        type: 'WATERPROOF' // 默认查询防水类型
      };

      getMaterialAccountList(params).then(res => {
        this.tableLoading = false;
        if (res.code === '200') {
          const data = JSON.parse(res.data) || [];
          this.tableData = data.rows || [];
          this.page = {
            total: data.total || 0,
            currentPage: page.currentPage,
            pageSize: page.pageSize
          };
        } else {
          this.tableData = [];
          this.page.total = 0;
          this.$message.error('获取材料账户列表失败');
        }
      }).catch(error => {
        console.log('index.vue ~ line: 283 ~ error ->', error);
        this.tableLoading = false;
        this.tableData = [];
        this.page.total = 0;
        this.$message.error('获取材料账户列表异常');
      });
    },

    // 分页大小变化
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: pageSize,
        type: 'WATERPROOF' // 默认查询防水类型
      };

      getMaterialAccountList(params).then(res => {
        this.tableLoading = false;
        if (res.code === '200') {
          const data = JSON.parse(res.data) || [];
          this.tableData = data.rows || [];
          this.page = {
            total: data.total || 0,
            currentPage: this.page.currentPage,
            pageSize: pageSize
          };
        } else {
          this.tableData = [];
          this.page.total = 0;
          this.$message.error('获取材料账户列表失败');
        }
      }).catch(error => {
        console.log('index.vue ~ line: 316 ~ error ->', error);
        this.tableLoading = false;
        this.tableData = [];
        this.page.total = 0;
        this.$message.error('获取材料账户列表异常');
      });
    },

    // 页码变化
    pageChange(page) {
      this.tableLoading = true;
      let params = {
        page: page,
        size: this.page.pageSize,
        type: 'WATERPROOF' // 默认查询防水类型
      };

      getMaterialAccountList(params).then(res => {
        this.tableLoading = false;
        if (res.code === '200') {
          const data = JSON.parse(res.data) || [];
          this.tableData = data.rows || [];
          this.page = {
            total: data.total || 0,
            currentPage: page,
            pageSize: this.page.pageSize
          };
        } else {
          this.tableData = [];
          this.page.total = 0;
          this.$message.error('获取材料账户列表失败');
        }
      }).catch(error => {
        console.log('index.vue ~ line: 349 ~ error ->', error);
        this.tableLoading = false;
        this.tableData = [];
        this.page.total = 0;
        this.$message.error('获取材料账户列表异常');
      });
    },

    // 选择变化
    handleSelectionChange(rows) {
      this.selectedRows = rows;
    },

    // 切换结算账号（暂时保留原代码结构，实际应该调用材料账户启用相关的API）
    openEnable(row) {
      this.$confirm(`是否确认启用?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let data = {
            acctNo: row.acctNo,
          };
          // 注意：这里应该调用材料账户启用相关的API，当前没有提供，暂时保留原代码结构
          console.log('启用操作', data);
          // 模拟成功响应
          this.$message({
            showClose: true,
            message: "启用成功",
            type: "success"
          });
          this.handleList();
        })
        .catch(() => { });
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
